import { css } from "styled-components";
import mediaQueries from "../../utils/mediaQuery/index";
import { DEVICES } from "../../utils/mediaQuery/consts";

var getViewportHideStyles = function getViewportHideStyles(on) {
  var resolveDisplayProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return "block";
  };
  return DEVICES.map(function (viewport) {
    return viewport in mediaQueries ? css(["", ";"], mediaQueries[viewport](css(["display:", ";"], on.indexOf(viewport) !== -1 ? "none" : resolveDisplayProp()))) : // "smallMobile" is not media query so we need to check it explicitly
    viewport === "smallMobile" && on.indexOf(viewport) !== -1 && css(["display:none;"]);
  });
};

export default getViewportHideStyles;